import { render, staticRenderFns } from "./CustomersRetentionStatistics.vue?vue&type=template&id=5e10ca98"
import script from "./CustomersRetentionStatistics.vue?vue&type=script&lang=ts"
export * from "./CustomersRetentionStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports